import {Heading} from '@primer/react'
import type {CommitGroup as CommitGroupType} from '../../types/commits-types'
import {EndOfFile, RenamedToHistory, useShouldClipTimeline} from './FileHistory'
import {useLoadDeferredCommitData} from '../../hooks/use-load-deferred-commit-data'
import {useFilters} from '../../contexts/FilterContext'
import {useCurrentRepository} from '@github-ui/current-repository'
import {Commits} from '../../shared/Commits'

export function CommitList({
  commitGroups,
  deferredDataUrl,
}: {
  commitGroups: CommitGroupType[]
  deferredDataUrl: string
}) {
  const filters = useFilters()
  const repo = useCurrentRepository()
  const deferredCommitData = useLoadDeferredCommitData(deferredDataUrl)

  return (
    <div className="mb-3" data-hpc>
      <Heading as="h2" className="sr-only">
        Commit History
      </Heading>

      <Commits
        leadingContent={<RenamedToHistory />}
        commitGroups={commitGroups}
        trailingContent={<EndOfFile />}
        repository={repo}
        deferredCommitData={deferredCommitData}
        shouldClipTimeline={useShouldClipTimeline()}
        currentBlobPath={filters.currentBlobPath}
      />
    </div>
  )
}

try{ CommitList.displayName ||= 'CommitList' } catch {}